import { Search, Plus, Trash2 } from 'lucide-react'
import type { InputHTMLAttributes } from 'react'
import { Fields, type Field, type Values } from './forms'

export function SearchField(props: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <div className="search-control">
      <Search size={19} aria-hidden="true" />
      <input {...props} className="search-input" type="search" />
    </div>
  )
}
export function EquipmentTypeIcon({ type }: { type: string }) {
  const t = type.toLowerCase()
  const kind = t.includes('экскаватор')
    ? 'excavator'
    : t.includes('бульдозер')
      ? 'bulldozer'
      : t.includes('погрузчик')
        ? 'loader'
        : t.includes('грейдер')
          ? 'grader'
          : t.includes('кран')
            ? 'crane'
            : t.includes('каток')
              ? 'roller'
              : t.includes('самосвал')
                ? 'dump'
                : 'truck'
  return (
    <span className="equipment-type-icon" title={type} aria-label={type} tabIndex={0}>
      <span className={`equipment-type-art ${kind}`} aria-hidden="true" />
      <span className="type-tooltip" role="tooltip">
        {type}
      </span>
    </span>
  )
}
export function Tabs({
  value,
  onChange,
  items,
}: {
  value: string
  onChange: (value: string) => void
  items: { value: string; label: string; count?: number }[]
}) {
  return (
    <div className="section-tabs" role="tablist">
      {items.map((item) => (
        <button
          type="button"
          key={item.value}
          role="tab"
          aria-selected={item.value === value}
          onClick={(event) => {
            onChange(item.value)
            event.currentTarget.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' })
          }}
        >
          {item.label}
          {item.count != null && <span>{item.count}</span>}
        </button>
      ))}
    </div>
  )
}
export function ObjectRows({
  title,
  rows,
  onChange,
  fields,
  empty,
  reorder = false,
}: {
  title: string
  rows: Values[]
  onChange: (rows: Values[]) => void
  fields: Field[]
  empty: Values
  reorder?: boolean
}) {
  return (
    <section className="array-editor">
      <header>
        <h3>{title}</h3>
        <button type="button" className="button secondary" onClick={() => onChange([...rows, { ...empty }])}>
          <Plus size={16} />
          Добавить
        </button>
      </header>
      {rows.map((row, index) => (
        <div className="array-row" key={index}>
          <Fields
            fields={fields}
            values={row}
            onChange={(key, value) =>
              onChange(rows.map((item, i) => (i === index ? { ...item, [key]: value } : item)))
            }
          />
          <button
            type="button"
            className="icon-button"
            aria-label={'Удалить строку ' + (index + 1)}
            onClick={() => onChange(rows.filter((_, i) => i !== index))}
          >
            <Trash2 size={17} />
          </button>
          {reorder && (
            <div className="row-order">
              <button
                type="button"
                className="icon-button"
                aria-label={'Переместить этап ' + (index + 1) + ' вверх'}
                disabled={index === 0}
                onClick={() => {
                  const result = [...rows]
                  ;[result[index - 1], result[index]] = [result[index], result[index - 1]]
                  onChange(result)
                }}
              >
                ↑
              </button>
              <button
                type="button"
                className="icon-button"
                aria-label={'Переместить этап ' + (index + 1) + ' вниз'}
                disabled={index === rows.length - 1}
                onClick={() => {
                  const result = [...rows]
                  ;[result[index + 1], result[index]] = [result[index], result[index + 1]]
                  onChange(result)
                }}
              >
                ↓
              </button>
            </div>
          )}
        </div>
      ))}
    </section>
  )
}
